import Vue from 'vue'

const requireContext = require.context('./', true, /.*\.vue$/)
requireContext.keys().forEach(file => {
    const comp = requireContext(file).default

    if (comp && comp.name)
    {
        Vue.component(comp.name, comp)
    }
})



// WEBPACK FOOTER //
// ./src/components/index.js